// Include scss
import "../scss/index.scss";

// Images
import "./images.js";
import "./hystmodal.min.js";


/* 
    Libs 
*/
import MouseFollower from "mouse-follower";
import "mouse-follower/src/scss/index.scss";
import gsap from "gsap";
import LazyLoad from "vanilla-lazyload";
import IMask from 'imask';

import 'vanilla-calendar-pro/styles/index.css';

import Swiper, { Autoplay } from 'swiper';
import { Pagination, Navigation, EffectFade, Lazy} from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

import { scrollTo, scrollIntoView } from 'scroll-js';



//import { Hammer } from "hammerjs";

//import AirDatepicker from 'air-datepicker'
//import 'air-datepicker/air-datepicker.css'

import search from "./search.js";
import objectPage from "./objectPage.js";
import imageMap from "./imageMap.js";
import Mmap from "./map.js";
import mobileMenu from './mobileMenu.js';
import bo from './bo.js';
import Fqa from './fqa.js';
import Clipboard from './clipboard.js';


/*
    APP sittings
*/

// Lazyload
document.addEventListener('DOMContentLoaded', () => {


    console.warn('Created by Georgiy Antipov a@topm.ru ');

    var myLazyLoad = new LazyLoad();

    // dvh
    const appHeight = () => document.documentElement.style.setProperty('--dynamic-height', `${window.innerHeight}px`)
    window.addEventListener('resize', appHeight)
    appHeight();

    setInterval(appHeight, 1000);


    // Слайдер на главной
    let sw = new Swiper(".js-swiper-gallery", {
        modules: [Pagination, Navigation,  Lazy],
        slidesPerView: "auto",
        loop: true,
        lazy: true,
        pagination: {
            el: ".js-swiper-gallery-pagination",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });


    const mm = new mobileMenu();

    // Преход по ссылке
    for(let link of document.querySelectorAll('[data-link]')) {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if(mm.isOpen()) {
                mm.close();
            }

            const href = link.getAttribute('href');
            const matches = href.match(/^.+(\#.+)$/);
            if(!matches[1]) {
                window.location.href = href;
                return;
            }
            const object = document.querySelector(matches[1]);

            if(!object) {
                window.location.href = href;
                return;
            }

            let headerHeight = document.querySelector(".hns-header").clientHeight;

            const elementTop = object.offsetTop + window.screenTop - headerHeight*1.5 + window.outerHeight - window.innerHeight ;

            console.log(elementTop)

            scrollTo( document.body, {top: elementTop,  behavior: "smooth", duration: 2, easing: 'ease-in-out' }).then(
                function () {
                    // done scrolling document's body to show myElement
                }
            );
        });
    }





    // Маска на телефон
    for(let input of document.querySelectorAll(".js-input-phone")) {
        const maskOptions = {
            mask: '+{7}(000)000-00-00'
        };
        const mask = IMask(input, maskOptions);
    }
});
